import classNames from 'classnames'

import { Skeleton } from '../../Skeleton'

import * as styles from './EntityProfileHeaderInfoItemLoading.module.css'

function EntityProfileHeaderInfoItemLoading() {
  return (
    <>
      <Skeleton className={classNames(styles.skeleton, styles.titleSkeleton)} />
      <Skeleton
        className={classNames(styles.skeleton, styles.contentSkeleton)}
      />
    </>
  )
}

export default EntityProfileHeaderInfoItemLoading
